import localConfig from "./config";

const imageConfig = {
  baseURL: localConfig.baseURL,
  postMedia: "/StorageService",
};

export default imageConfig;
